/* import __COLOCATED_TEMPLATE__ from './left-slot.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  width: string;
  hidden?: boolean;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
  Blocks: any;
}

const LeftSlot = templateOnlyComponent<Signature>();
export default LeftSlot;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Layout::Module::LeftSlot': typeof LeftSlot;
    'layout/module/left-slot': typeof LeftSlot;
  }
}
